module.exports = __webpack_public_path__ + "static/media/CL_AMB upd.222be9d1.mp3";